import { BlurFade } from '@/components/ui/blur-fade';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import {
  Ticket,
  Zap,
  Globe,
  BookOpen,
  Mail,
  Radio,
} from 'lucide-react';

const features = [
  {
    icon: Ticket,
    title: 'Ticket Management',
    description: 'Full lifecycle tracking from creation to resolution. Assign, prioritize, and monitor with SLA-aware timelines and business hours support.',
    span: 'lg:col-span-2',
  },
  {
    icon: Zap,
    title: 'Automation Engine',
    description: 'Build no-code rules for tickets and knowledge base articles. Event-driven triggers, time-based schedules, and 16+ action types for notifications, assignments, and escalations.',
    span: '',
  },
  {
    icon: Globe,
    title: 'Customer Portal',
    description: 'Self-service portal with magic link authentication, ticket submission, article feedback, and related articles linked directly to support tickets.',
    span: '',
  },
  {
    icon: BookOpen,
    title: 'Knowledge Base',
    description: 'Public and internal articles with ticket linking, customer feedback ratings, SEO-friendly slugs, content freshness monitoring, and full automation engine integration.',
    span: '',
  },
  {
    icon: Mail,
    title: 'Email Integration',
    description: 'Inbound email-to-ticket creation via SendGrid. Outbound notifications with conversation threading keep everyone in sync.',
    span: '',
  },
  {
    icon: Radio,
    title: 'Real-Time Updates',
    description: 'Live ticket updates, typing indicators, and agent presence powered by SignalR. Your team stays connected in real time.',
    span: 'lg:col-span-2',
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <BlurFade inView>
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground">
              Everything you need to deliver exceptional support
            </h2>
            <p className="mt-3 sm:mt-4 text-sm sm:text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
              A complete platform that brings together ticketing, automation, self-service,
              and analytics in one unified solution.
            </p>
          </div>
        </BlurFade>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((feature, index) => (
            <BlurFade key={feature.title} delay={index * 0.1} inView>
              <Card
                className={`group h-full hover:shadow-lg hover:border-primary/20 transition-all duration-300 ${feature.span}`}
              >
                <CardHeader>
                  <div className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <feature.icon className="h-6 w-6" />
                  </div>
                  <CardTitle className="text-xl">{feature.title}</CardTitle>
                  <CardDescription className="text-base leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
}
